import { observer } from "mobx-react-lite";
import { FC } from "react";
import { AuthCardEmailPassword } from "@/components/auth/auth-card-email-password";
import { usePublicAppStore } from "@/store";
import { appRoutes } from "@/app/router";
import { Navigate } from "react-router";
import { AuthLayout } from "@/components/auth/layout/auth-layout";

export const LogInEmailPasswordPage: FC = observer(() => {
  const { publicStore } = usePublicAppStore();

  if (publicStore.auth.isAuthenticated) {
    return <Navigate to={appRoutes.notesList({}).path} />;
  }

  return (
    <AuthLayout>
      <AuthCardEmailPassword />
    </AuthLayout>
  );
});
